<div class="image-box">
	<picture *ngIf="gif"
		class="gif-height">
		<source *ngIf="gifMobile"
			media="(max-device-width: 640px)"
			[srcset]="scene7service(gifMobile, 'gif', true)" />
		<img [src]="scene7service(gif, 'gif', true)"
			[attr.alt]="altTagService(altText || '', itemTitle)"
			[loading]="willLazyLoad ? 'lazy' : 'eager'" />
	</picture>
	<picture *ngIf="image && !gif">
		<source *ngIf="mobileImg"
			[srcset]="scene7service(mobileImg, imagePreset, false)"
			media="(max-width: 766px)" />
		<img [src]="scene7service(image, imagePreset, false)" class="loaded"
			[attr.alt]="altTagService(altText || '', itemTitle)"
			[loading]="willLazyLoad ? 'lazy' : 'eager'" />
	</picture>
</div>
